import React from 'react';
import { Nav, NavItem, NavLink, DropdownItem } from 'reactstrap';
import { faCaretUp } from '@fortawesome/free-solid-svg-icons/faCaretUp';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons/faCaretDown';
import FontAwesomeSVGIcon from '../../elements/icons/fontAwesomeSVGIcon';
import COLORS from '../../../../common/colors'
import MediaQuery from 'react-responsive';
import UserMenu from './userMenu';
import ColorSignUpButton from './colorSignUpButton';
import getConfig from 'next/config';
import SelectByPlatform from '../../../workplace/common/selectByPlatform';
import ColorLoginUpButton from './colorLoginButton';

const config = getConfig().publicRuntimeConfig;

// TODO Add undeline feedback to the navlinks with links in them
// TODO dropdown for the user profile

export default class LoginMenu extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isCauseMenuOpen: false,
            isMissionsMenuOpen: false,
            isGetInvolved: false
        };

    }

    registerSearchClick = () => {

        if (window.eventDispatcher) {
            window.eventDispatcher.dispatchEventSync('headerSearchClick', {}, { amplitude: true });
        }

        window.location.href = window.location.origin + "/search";
    }

    toggleCausesMenu = () => {
        this.setState({ 
            isCauseMenuOpen: !this.state.isCauseMenuOpen,  isMissionsMenuOpen: false, isGetInvolved: false
        });
    }

    toggleMissionsMenu = () => {
        this.setState({
            isMissionsMenuOpen: !this.state.isMissionsMenuOpen, isCauseMenuOpen: false, isGetInvolved: false
        })
    }

    toggleIsGetInvolvedMenu = () => {
        this.setState({
            isGetInvolved: !this.state.isGetInvolved, isCauseMenuOpen: false, isMissionsMenuOpen: false
        })
    }
 
    render() {

        const {
            color, session, toggleLogInModal, toggleSignUpModal, width, tenantConfig, loginBackgroundColor
        } = this.props;

        let borderBottomValue = 'none';
        if (session && session.user) {
            return (
                <Nav navbar className="ml-auto header-menu px-0">
                    <UserMenu
                        session={session}
                        color={color || '#999999'}
                        width={width}
                        subdomain={this.props.subdomain}
                        tenantConfig={tenantConfig}
                        _csrf={this.props._csrf}
                        loginBackgroundColor={loginBackgroundColor}
                    />
                </Nav>
            );
        }
        let loginBackgroundStyle = {
            backgroundColor: width < 768 && loginBackgroundColor ? loginBackgroundColor : ""
        };
        return (
            <Nav navbar className="header-menu d-flex" style={loginBackgroundStyle}>
                <MediaQuery maxWidth={992} device={{ width }} >
                    {/* <NavItem style={{borderBottom: borderBottomValue}}>
						<NavLink style={color ? { color } : {}} href="/">
							Home
						</NavLink>
					</NavItem> */}
                    {!this.props.hideSearch && this.props.subdomain === 'www' ? <NavItem>
                        <NavLink style={color ? { color } : {}} onClick={this.props.registerSearchClick} className="search-nav-link">
                            <span className="search-text-collapse" style={color ? { color } : {}} href="/">
                                Search
							</span>
                        </NavLink>
                    </NavItem> : null}


                    <DropdownItem toggle={false} onClick={() => this.toggleCausesMenu()} style={{
                        textAlign: 'left', padding: '0.5rem', minHeight: '40px', borderBottom: '1px solid rgba(0,0,0,0.2)', color: '#00000080', display: "flex", outline: 'none', background: 'none'
                    }}
                    > Explore Causes
					    {this.state.isCauseMenuOpen ? <FontAwesomeSVGIcon icon={faCaretUp} className="ml-auto" width="10" /> : <FontAwesomeSVGIcon icon={faCaretDown} className="ml-auto" width="10" />}
                    </DropdownItem>

                    {this.state.isCauseMenuOpen && tenantConfig.header && tenantConfig.header.menuLinks.map((menuLink, index) => {
                        return (menuLink.heading !== 'Missions' ? (<NavLink key={index} className={`navbar-cause-link`} style={color ? { color } : {}} href={menuLink.src}>
                            {menuLink.heading}
                        </NavLink>) : null)
                    })
                    }

                    <DropdownItem toggle={false} onClick={() => this.toggleMissionsMenu()} style={{
                        textAlign: 'left', padding: '0.5rem', minHeight: '40px', borderBottom: '1px solid rgba(0,0,0,0.2)', color: '#00000080', display: "flex", outline: 'none', background: 'none'
                    }}>Missions
					    {this.state.isMissionsMenuOpen ? <FontAwesomeSVGIcon icon={faCaretUp} className="ml-auto" width="10" /> : <FontAwesomeSVGIcon icon={faCaretDown} className="ml-auto" width="10" />}
                    </DropdownItem>
                    {this.state.isMissionsMenuOpen &&  tenantConfig.header && tenantConfig.header.menuLinks.map(link => {
                       return ( link.heading === 'Missions' ? (
                            link.missions.map((menuLink, index) =>{
                                return <NavLink key={index} className={`navbar-cause-link`} style={color ? { color } : {}} href={menuLink.src}>
                                            {menuLink.heading}
                                        </NavLink>
                            })
                        ) : null)
                    })}
                    <SelectByPlatform>
                        <NavItem name="www" style={{ borderBottom: borderBottomValue }}>
                            <NavLink style={color ? { color } : {}} rel="noopener noreferrer" target="_blank" href='https://workplace.giveindia.org/'>
                                Workplace Giving
						</NavLink>
                        </NavItem>
                        <NavItem name="www" style={{ borderBottom: borderBottomValue }}>
                            <NavLink style={color ? { color } : {}} href={`${config.fundraisersPlatformUrl}`} rel="noopener noreferrer" target="_blank">
                                Fundraisers
                            </NavLink>
                        </NavItem>
                        <NavItem name="www" style={{ borderBottom: borderBottomValue }}>
                            <NavLink style={color ? { color } : {}} href={`${config.oldPlatformUrl}`} rel="noopener noreferrer" target="_blank">
                                Previous Platform
						</NavLink>
                        </NavItem>
                        <NavItem name="www" style={{ borderBottom: borderBottomValue }}>
                            <NavLink style={color ? { color } : {}} href="/aboutus" onClick={() => window.location.href = "/aboutus"}>
                                About Us
						</NavLink>
                        </NavItem>
                    </SelectByPlatform>

                   
                    {/* {
                    <DropdownItem toggle={false} onClick={() => this.toggleIsGetInvolvedMenu()} style={{
                        textAlign: 'left', padding: '0.5rem', minHeight: '40px', borderBottom: '1px solid rgba(0,0,0,0.2)', color: '#00000080', display: "flex", outline: 'none', background: 'none'
                            }}> Get Involved
					        {this.state.isGetInvolved ? <FontAwesomeSVGIcon icon={faCaretUp} className="ml-auto" width="10" /> : <FontAwesomeSVGIcon icon={faCaretDown} className="ml-auto" width="10" />}
                    </DropdownItem>
                    } */}
                        {/* {  this.state.isGetInvolved ? (
                            <>
                               
                                <NavLink className="navbar-cause-link" rel="noopener noreferrer" target="_blank" href='https://workplace.giveindia.org/'>
                                        Workplace Giving
                                </NavLink>

                            </>
                        ): null } */}
                   
                </MediaQuery>



                <MediaQuery minWidth={992} device={{ width }}>
                    <SelectByPlatform>
                        <NavItem name={"www"}>
                        </NavItem>
                        <NavItem name={"www"} className="align-self-center">
                            <ColorLoginUpButton 
                                toggleLogInModal={toggleLogInModal}
                                color={color}
                            />
                        </NavItem>
                    </SelectByPlatform>
                </MediaQuery>
                <style global jsx>
                    {
                        `
						.search-text-collapse {
							font-size: 14px;
							padding-left: 0 !important;
						}

					`
                    }
                </style>
            </Nav>
        );
    }
}
